import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { track } from "../../analytics";
import "./Header.css";

const NAV = [
  { to: "/", label: "Home", end: true, event: "btnPress_home" },
  { to: "/guides", label: "Guides", event: "btnPress_guides" },
  { to: "/guides/convert-eps-to-png", label: "Convert", event: "btnPress_convert" },
  { to: "/faq", label: "FAQ", event: "btnPress_faq" },
  { to: "/about-magicapps", label: "About", event: "btnPress_about" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="site-header">
      <div className="container site-header__inner">
        <Link to="/" className="brand" onClick={() => setOpen(false)}>
          <span className="brand__mark" aria-hidden="true">EPS</span>
          <span className="brand__name">EPS&nbsp;Viewer</span>
        </Link>

        <button
          className={`nav-toggle ${open ? "is-open" : ""}`}
          aria-label="Toggle menu"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          <span></span><span></span><span></span>
        </button>

        <nav className={`site-nav ${open ? "is-open" : ""}`}>
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => "site-nav__link" + (isActive ? " is-active" : "")}
              onClick={() => { track(item.event); setOpen(false); }}
            >
              {item.label}
            </NavLink>
          ))}
          <a
            href="/contact"
            className="site-nav__link"
            onClick={() => { track("btnPress_contact"); setOpen(false); }}
          >
            Contact
          </a>
          <Link
            to="/"
            className="btn btn--primary site-nav__cta"
            onClick={() => { track("btnPress_openViewer"); setOpen(false); }}
          >
            Open Viewer
          </Link>
        </nav>
      </div>
    </header>
  );
}
